module.exports = __webpack_public_path__ + "static/media/shelter.4370ea85.svg";